import { PHOTO_TRANSMISSION_PLAN } from 'spypoint/src/checkout-module/order/core/productTypes'
import PrimaryButton from 'shared-module/new-components/buttons/PrimaryButton'
import { useCart } from 'spypoint/src/checkout-module/order/core/cart.hooks'
import useSelectedCamera from 'camera-module/camera/core/useSelectedCamera'
import useUser from 'user-module/user/core/useUser'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useECommerceFlag } from 'spypoint/src/ecommerce-module/hooks/UseEcommerceFlag'
import { useLDFlags } from 'spypoint/src/launchDarkly-module/launchDarklyFlagsContext'
import { useDispatch } from 'react-redux'
import useConfirmationDialogActions from 'shared-module/components/confirmation/useConfirmationDialogActions'
import ConfirmationDialog from 'shared-module/components/confirmation/ConfirmationDialog'

const AddToCartButton = ({ onSelectPlan, isStripeSubscription, plan, periodType, addPhotoTransmissionPlanToBasket }) => {
  const { addToCart, navigateToCart } = useCart()
  const { t } = useTranslation()
  const history = useHistory()
  const selectedCamera = useSelectedCamera()
  const dialogWarning = useConfirmationDialogActions()
  const eCommerceEnabled = useECommerceFlag()
  const { flags } = useLDFlags()
  const stripUpdatesEnabled = flags && flags['e-commerce-block-stripe-updates']
  const user = useUser()

  const goToCheckout = () => {
    history.push({
      pathname: '/checkout',
      search: 'checkout=stripe',
    })
  }

  const addPhotoTransmissionPlanToCart = () => {
    addToCart({
      productId: PHOTO_TRANSMISSION_PLAN,
      cameraId: selectedCamera.id,
      paymentFrequency: periodType,
      plan: plan.id,
    })
    navigateToCart()
  }
  const addPhotoTransmissionPlanToCheckoutDirectly = () => {
    addToCart({
      productId: PHOTO_TRANSMISSION_PLAN,
      cameraId: selectedCamera.id,
      paymentFrequency: periodType,
      plan: plan.id,
    })
    goToCheckout()
  }
  const upgradingDisabled = () => {
    dialogWarning.open()
  }

  if (eCommerceEnabled && !isStripeSubscription) {
    return <PrimaryButton onClick={() => addPhotoTransmissionPlanToBasket(plan)}>{ t('app:checkout_process.add_to_cart') }</PrimaryButton>
  }
  if (eCommerceEnabled && isStripeSubscription) {
    return (
      <>
        <PrimaryButton onClick={() => stripUpdatesEnabled ? upgradingDisabled() : addPhotoTransmissionPlanToCheckoutDirectly()}>{ t('app:checkout_process.add_to_cart') }</PrimaryButton>
        <ConfirmationDialog
          open={dialogWarning.isOpen}
          title={t('app:checkout_process.migration_auto_renew.title')}
          text={t('app:checkout_process.migration_auto_renew.text')}
          onConfirm={dialogWarning.close}
          confirmText={t('app:checkout_process.migration_auto_renew.confirm')}
        />
      </>
    )
  }

  if (user.cartEnabled && !eCommerceEnabled) {
    return <PrimaryButton onClick={addPhotoTransmissionPlanToCart} id={`${plan.id}_add_to_cart`}>{ t('app:checkout_process.add_to_cart') }</PrimaryButton>
  }
  return <PrimaryButton onClick={() => onSelectPlan({ plan, frequency: periodType })} id={`${plan.id}_buy`}>{ t('app:checkout_process.add_to_cart') }</PrimaryButton>
}

export default AddToCartButton
